<template>
  <div class="order-list">
    <el-card class="query-card">
      <el-form :model="SysMerAdminReqVo" ref="queryForm" label-width="auto" size="small" inline>


        <el-row :gutter="30" style="display: flex; flex-wrap: wrap; align-items: center;">


          <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
            <el-form-item :label="$t('findManagers.loginName')" prop="maMerLgginAccount">
              <div class="input-with-more">
                <el-input v-model="SysMerAdminReqVo.maMerLgginAccount" :placeholder="$t('please_input')" clearable class="full-width" />
              </div>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12"  :md="{span:8,offset:8}"
                  :lg="{span:8,offset:8}"
                  :xl="{span:8,offset:8}">
            <el-form-item :label="$t('findManagers.status')" prop="maStatus">
              <el-select v-model="SysMerAdminReqVo.maStatus" :placeholder="$t('choose')" clearable class="full-width">
                <el-option :label="$t('findManagers.normal')" value="1"></el-option>
                <el-option :label="$t('findManagers.stopUsing')" value="-1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>



          <el-col :span="24">
            <el-form-item style="display: flex; justify-content: center; margin-top: 20px; margin-bottom: 10px;" label-width="0">
              <el-button type="primary" @click="handleSearch">{{ $t('query') }}</el-button>
              <el-button @click="handleReset">{{ $t('reset') }}</el-button>
            </el-form-item>
          </el-col>

        </el-row>
      </el-form>
    </el-card>



    <div class="action-toolbar">
      <el-button
        v-if="hasPermission('admin/findManagers', 'button_add')"
        @click="handleAdd"
        type="primary"
        icon="el-icon-plus"
      >
        {{ $t('button.add') }}
      </el-button>



      <el-button
          v-if="hasPermission('admin/findManagers', 'button_update')"

          type="primary"
          icon="el-icon-edit"
          @click="handleEdit"
      >
        {{$t('button.update')}}
      </el-button>


      <el-button
          v-if="hasPermission('admin/findManagers', 'button_delete')"
          type="danger"
          icon="el-icon-delete"
          @click="handleDelete"
      >
        {{ $t('button.delete') }}
      </el-button>


      <el-button
          v-if="hasPermission('admin/findManagers', 'button_resetpassword')"
          type="warning"
          icon="el-icon-key"
          @click="handleResetPassword"
      >
<!--        重置密码-->
        {{$t('button.resetPasswords')}}
      </el-button>


      <el-button
          v-if="hasPermission('admin/findManagers', 'button_stop')"
          type="danger"
          icon="el-icon-video-pause"
          @click="handleStop"
      >
        {{ $t('button.stop') }}
      </el-button>


      <el-button
          v-if="hasPermission('admin/findManagers', 'button_start')"
          type="success"
          icon="el-icon-video-pause"
          @click="handleEnable"
      >
        {{ $t('button.enable') }}
      </el-button>


    </div>


    <el-card class="table-card" style="margin-top: 16px; overflow-x: auto;">
      <el-table :data="tableData" @sort-change="handleSortChange" border  style="width: 100%" v-loading="loading" show-overflow-tooltip
                :cell-style="{whiteSpace: 'nowrap'}"
                :header-cell-style="{whiteSpace: 'nowrap'}"
      >

                <el-table-column

                  width="120" align="center" :label="$t('choose')">
                  <template slot-scope="scope">
                    <el-radio
                      v-model="selectedRowId"
                      :label="scope.row.maId"
                      :disabled="scope.row.maIsDefault == 0"
                      @change="handleRadioChange(scope.row)"
                    >
                      {{''}}
                    </el-radio>
                  </template>
                </el-table-column>


        <el-table-column prop="maMerLgginAccount"  :label="$t('findManagers.loginName')" :min-width="columnWidths.loginName"></el-table-column>

        <el-table-column prop="maName" :label="$t('findManagers.adminNameAll')" :min-width="columnWidths.adminNameAll"></el-table-column>
        <el-table-column  :label="$t('findManagers.status')" :min-width="columnWidths.status">
          <template slot-scope="scope">
            <span>
                  <span v-if="scope.row.maStatus == 1">{{ $t('findManagers.normal') }}</span>
            <span v-else-if="scope.row.maStatus == -1">{{ $t('findManagers.stopUsing') }}</span>
            <span v-else-if="scope.row.maStatus == -2">{{ $t('findManagers.delete') }}</span>
            <span v-else>{{ $t('statusUnknown') }}</span>
            </span>
          </template>
        </el-table-column>

        <el-table-column
          :label="$t('findManagers.adminRole')"
          :min-width="columnWidths.adminRole"
        >
          <template slot-scope="scope">
            {{
              scope.row.roles && scope.row.roles.length
                ? scope.row.roles
                  .map(item =>
                    $i18n.locale === 'en-US'
                      ? item.mrRoleNameEn
                      : item.mrRoleNameCn
                  )
                  .join(' , ')
                : '-'
            }}
          </template>
        </el-table-column>

        <el-table-column prop="maLoginName" :label="$t('findManagers.creator')" :min-width="columnWidths.creator"></el-table-column>
        <el-table-column prop="maOprtime" :label="$t('findManagers.createdate')" :min-width="columnWidths.createdate"></el-table-column>


      </el-table>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.page"
        :page-sizes="[10, 20, 50]"
        :page-size="pagination.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
        style="margin-top: 16px; text-align: right;"
      />
    </el-card>


    <!--  弹窗  -->
    <el-drawer
      :title="dialogTitle"
      :visible.sync="updateDialogVisible"
      :before-close="handleDrawerClose"
      direction="rtl"
      size="50%"
    >

      <el-form
        ref="form"
        :model="formData"
        label-width="120px"
        class="drawer-form"
        :rules="rules"
      >

        <el-form-item :label="$t('findManagers.loginName')" required prop="maMerLgginAccount">
          <el-input
              v-model="formData.maMerLgginAccount"
              :disabled="dialogType === 'check' || dialogType === 'edit'"
          />
        </el-form-item>

        <el-form-item :label="$t('findManagers.password')" required prop="maLoginPwd"   v-if="dialogType === 'add'">
          <el-input v-model="formData.maLoginPwd" />
        </el-form-item>

        <el-form-item :label="$t('findManagers.confirmPassword')" required prop="renewPass"  v-if="dialogType === 'add'">
          <el-input v-model="formData.renewPass" />
        </el-form-item>

        <el-form-item :label="$t('findManagers.adminNameAll')" required prop="maName">
          <el-input v-model="formData.maName" :disabled="dialogType === 'check'"/>
        </el-form-item>

        <el-form-item :label="$t('findManagers.adminRole')" required prop="roleNames">
          <el-input
            v-model="formData.roleNames"
            readonly
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="openRoleDialog"
            />
          </el-input>
        </el-form-item>


        <el-form-item :label="$t('findManagers.remark')"  prop="maRemark">
          <el-input v-model="formData.maRemark" :disabled="dialogType === 'check'"/>
        </el-form-item>


      </el-form>


      <div class="drawer-footer">
        <el-button @click="updateDialogVisible = false">
          {{$t('cancel')}}
        </el-button>


        <el-button
          type="primary"
          :loading="updateLoading"
          @click="submitForm"
        >
          {{ $t('sure') }}
        </el-button>


      </div>

    </el-drawer>


    <el-dialog
      :title="$t('findManagers.pleaseSelecTheRolePermissions')"
      :visible.sync="roleDialogVisible"
      append-to-body
      width="800px"
      @close="closeRoleDialog"
    >

      <el-form
        :inline="true"
        size="small"
        class="role-query-form"
      >
        <el-form-item :label="$t('findManagers.roleNameInChinese')">
          <el-input
            v-model="roleQuery.mrRoleNameCn"
            clearable

          />
        </el-form-item>

        <el-form-item :label="$t('findManagers.roleName')">
          <el-input
            v-model="roleQuery.mrRoleNameEn"
            clearable

          />
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="searchRole"
          >
<!--            查询-->
            {{this.$t('findManagers.query')}}
          </el-button>

        </el-form-item>
      </el-form>


      <el-table
        class="role-table"
        ref="roleTable"
        :data="roleList"
        row-key="mrId"
        border
        height="300px"
        @selection-change="handleRoleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="55"
          align="center"
        />

        <el-table-column
          prop="mrId"
          label="ID"
        />

        <el-table-column
          prop="mrRoleNameCn"
          :label="$t('findManagers.roleNameInChinese')"
        />

        <el-table-column
          prop="mrRoleNameEn"
          :label="$t('findManagers.roleName')"
        />

        <el-table-column
          prop="mrRemark"
          :label="$t('findManagers.roleDescription')"
        />


      </el-table>


      <div
        style="margin-top:15px;text-align:right"
      >
        <el-pagination
          background
          layout="total, sizes, prev, pager, next"
          :current-page="rolePagination.page"
          :page-size="rolePagination.limit"
          :page-sizes="[10,20,50,100]"
          :total="rolePagination.total"
          @current-change="handleRolePageChange"
          @size-change="handleRoleSizeChange"
        />
      </div>

      <div slot="footer">
        <el-button @click="roleDialogVisible = false">
          {{ $t('cancel') }}
        </el-button>

        <el-button
          type="primary"
          @click="confirmRoleSelection"
        >
          {{ $t('sure') }}
        </el-button>
      </div>
    </el-dialog>


    <!--重置密码-->
    <el-dialog
        :title="$t('button.resetPasswords')"
        :visible.sync="resetPasswordVisible"
        width="450px"
    >

      <el-form
          ref="resetPasswordForm"
          :model="resetPasswordData"
          label-width="100px"
      >

        <el-form-item :label="$t('findManagers.syslogname')">
          <el-input
              v-model="resetPasswordAccount"
              disabled
          />
        </el-form-item>


        <el-form-item :label="$t('findManagers.newPassword')">
          <el-input
              v-model="resetPasswordData.resetPass"
              show-password
          >
            <el-button
                slot="append"
                @click="generatePassword"
            >
<!--              随机生成-->
              {{this.$t('findManagers.random')}}
            </el-button>
          </el-input>
        </el-form-item>


      </el-form>


      <span slot="footer">

    <el-button
        @click="resetPasswordVisible=false"
    >
<!--      取消-->
      {{this.$t('cancel')}}
    </el-button>


    <el-button
        type="primary"
        :loading="resetPasswordLoading"
        @click="submitResetPassword"
    >
<!--      确定-->
      {{this.$t('sure')}}
    </el-button>

  </span>


    </el-dialog>


  </div>




</template>

<script>
import { hasPermission } from "@/utils/permission";
export default {
  name: "OrderList",
  data() {


    return {
      endPickerOptions: {
        disabledDate: (time) => {
          if (!this.SysMerOperatelogReqVo.startTime) {
            return false;
          }

          return (
            time.getTime() <
            new Date(this.SysMerOperatelogReqVo.startTime).getTime()
          );
        }
      },
      loading: false,
      SysMerAdminReqVo: {
        maMerLgginAccount:"",
        maStatus:"",

        sortField: undefined,
        sortOrder: undefined
      },
      selectedRowData: "", // 当前行全部数据
      selectedRowIds: [],  // 选择id
      selectedRowId:"",

      updateDialogVisible: false,//弹窗
      dialogType: '', //弹窗类型
      updateLoading:false,


      auditLoading: false,
      moreDialogVisible: false,

      hasSearched: false,   //  是否有进行查询

      checkAllCurrency: false,

      downloadLoading: false,
      tableData: [],

      columnWidths:{},
      // 弹窗
      formData: {
        maId:"",
        maMerLgginAccount:"",
        maLoginPwd: '',
        renewPass: '',
        maName: '',
        roleNames: '',
        roleIdList: [],
        maRemark: '',

      },
      roleQuery: {
        mrRoleNameCn: '',
        mrRoleNameEn: ''
      },
      rolePagination: {
        page: 1,
        limit: 10,
        total: 0
      },
      dialogTitle:"",
      handleDrawerClose(done) {

        this.$refs.form && this.$refs.form.resetFields();
        this.formData = {
          maId:"",
          maMerLgginAccount:"",
          maLoginPwd: '',
          renewPass: '',
          maName: '',
          roleNames: '',
          roleIdList: [],
          maRemark: '',
        };

        this.checkAllCurrency = false;

        done();
      },
      // 角色
      roleDialogVisible:false,
      roleList: [],
      selectedRoles: [],

      // 重置密码
      resetPasswordAccount: '',
      resetPasswordVisible:false,
      resetPasswordLoading:false,
      resetPasswordData:{
        maId:"",
        maMerLgginAccount:"",
        resetPass:""
      },

      pagination: {
        page: 1,
        limit: 10,
        total: 0,
      },
      pages:"",





    };
  },
  created() {
     this.handleSearch(); // 初始化加载数据
   // this.refundIsCheck = sessionStorage.getItem("refundIsCheck");
  },
  mounted() {
    this.$nextTick(() => {
      this.initColumnWidths();
    });
  },

  // 发送变化重新计算
  computed:{
    selectableIds() {
      // 过滤出满足条件的行，提取它们的 upId
      return this.tableData
        .filter(item => item.upMercheckStatus == 0)
        .map(item => item.upId);
    },
    rules() {

      const validateRenewPass = (rule, value, callback) => {
        if (!value) {
          callback(new Error(this.$t('findManagers.pleaseReEnterTheNewPasswordToConfirm')));
        } else if (value !== this.formData.maLoginPwd) {
          callback(new Error(this.$t('findManagers.passwordDifferent')));
        } else {
          callback();
        }
      };

      return {
        maMerLgginAccount: [
          { required: true, message: this.$t('findManagers.pleaseEnterLoginName'), trigger: 'blur' },
          { min: 2, max: 15, message: this.$t('findManagers.loginNameLength'), trigger: 'blur' }
        ],
        maLoginPwd: [
          { required: true, message: this.$t('findManagers.pleaseEnterPassword'), trigger: 'blur' },
          { min: 8, message: this.$t('findManagers.passwordMinLength'), trigger: 'blur' }
        ],
        renewPass: [
          { required: true, validator: validateRenewPass, trigger: 'blur' }
        ],
        maName: [
          { required: true, message: this.$t('findManagers.pleaseEnterName'), trigger: 'blur' },
          { min: 2, max: 15, message: this.$t('findManagers.nameLength'), trigger: 'blur' }
        ],
        roleNames: [
          { required: true, message: this.$t('findManagers.pleaseSelectRole'), trigger: 'blur' }
        ]
      };
    }
  },
  methods: {
    // 按钮
    hasPermission,
    // 排序
    handleSortChange({ column, prop, order }) {
      // prop 是排序的字段名 (例如 'tsId')
      // order 是排序方式：'ascending' (升序), 'descending' (降序), 或者 null (默认不排序)
      if (order === null) {
        this.SysMerAdminReqVo.sortField = undefined;
        this.SysMerAdminReqVo.sortOrder = undefined;
      } else {
        // 正常赋值升序或降序
        this.SysMerAdminReqVo.sortField = prop;
        this.SysMerAdminReqVo.sortOrder = order;
      }

      // 重新调用获取列表的接口
      this.fetchOrderList();
    },
    // 数据绑定
    handleRadioChange(row) {
      this.selectedRowData = row;
    },

    // 查询
    handleSearch() {
      this.pagination.page = 1; // 重置页码
      this.fetchOrderList();
    },
    // 重置
    handleReset() {
      this.$refs.queryForm.resetFields();

      this.hasSearched = false;
      //this.handleSearch();
    },
    //
    async fetchOrderList() {
      this.loading = true;
      try {
        const params = {
          maStatus: this.SysMerAdminReqVo.maStatus || undefined,
          maMerLgginAccount: this.SysMerAdminReqVo.maMerLgginAccount || undefined,



          page: this.pagination.page,
          limit: this.pagination.limit,
        };

        const res = await this.$axios.post('/api/meradmin/users',  params );

        if (res.data.code === 0) {
          const responseData = res.data.data;

          this.tableData = responseData.records || [];

          this.pagination.total = Number(responseData.total) || 0;
          this.pagination.page = Number(responseData.current) || this.pagination.page;
          this.pagination.limit = Number(responseData.size) || this.pagination.limit;

          if (this.pagination.total > 0) {
            this.hasSearched = true;
          }
        } else {
          this.$message.error(res.data.msg);
          this.tableData = [];
          this.pagination.total = 0;
        }
      } catch (err) {
        console.error('查询订单失败:', err);
        this.$message.error(this.$t('requestFailed'));
        this.tableData = [];
        this.pagination.total = 0;
      } finally {
        this.loading = false;
      }
    },
    // 弹窗提交
    submitForm() {

      this.$refs.form.validate(async (valid) => {
        if (!valid) return;



        if (this.dialogType === 'add') {
          this.handleCreate();
        } else {
          this.handleUpdateSubmit();
        }
      });
      //this.updateDialogVisible = false;
    },
    // 新增发送
    async handleCreate() {
      try {

        this.updateLoading = true;

        const params = {
          ...this.formData,

        };

        const res = await this.$axios.post(
          '/api/meradmin/add',
          params
        );

        if (res.data.code === 0) {
          this.$message.success(this.$t('succeed'));

          this.updateDialogVisible = false;

          this.fetchOrderList();

          // 清空表单
          this.resetForm();

        } else {
          this.$message.error(res.data.msg || '新增失败');
        }

      } catch (e) {
        console.error(e);
        this.$message.error('新增失败');
      } finally {
        this.updateLoading = false;
      }
    },
    // 修改发送
    async handleUpdateSubmit() {
      try {

        this.updateLoading = true;

        const params = {
          //...this.formData

          maId : this.formData.maId  || undefined,
          maMerLgginAccount : this.formData.maMerLgginAccount  || undefined,
          maName : this.formData.maName  || undefined,
          roleIdList : this.formData.roleIdList  || undefined,
          maRemark : this.formData.maRemark  || undefined,
        };

        const res = await this.$axios.put(
            "/api/meradmin/update",
            params
        );

        if (res.data.code === 0) {

          this.$message.success(this.$t('updaSucceed'));

          this.updateDialogVisible = false;

          this.fetchOrderList();

          this.resetForm();

        } else {

          this.$message.error(res.data.msg || "修改失败");

        }

      } catch (e) {

        console.error(e);

        this.$message.error("修改失败");

      } finally {

        this.updateLoading = false;

      }
    },
    // 新增弹窗
    async handleAdd() {

      try {

        this.dialogType = 'add';
        //this.dialogTitle = this.$t('showMerbankaccount.merbankaccount_add');
        this.dialogTitle = this.$t('button.add');

        this.resetForm();

        this.updateDialogVisible = true;

      } catch (e) {
        console.error(e);

        this.$message.error(  $t('loginPage.serverError') );

      }
    },
    // 修改弹窗
    async handleEdit() {

      if (!this.selectedRowData) {
        this.$message.warning(this.$t('alert_select'));
        return;
      }

      this.dialogType = "edit";
      this.dialogTitle = this.$t("button.update");

      // 先清空校验
      //this.resetForm();

      // 回填数据
      this.formData = {
        ...this.selectedRowData,
        renewPass: "",

        roleIdList: this.selectedRowData.roles
            ? this.selectedRowData.roles.map(item => Number(item.mrId))
            : [],

        roleNames: this.selectedRowData.roles
            ? this.selectedRowData.roles.map(item => item.mrRoleNameCn).join(",")
            : ""
      };

      this.updateDialogVisible = true;
    },
     // 打开角色选择弹窗
    openRoleDialog() {
      if (this.dialogType === 'check') return;
      this.roleDialogVisible = true;
      this.rolePagination.page = 1;
      this.fetchRoleList(); // 调用接口获取数据
    },
    // 获取角色数据
    async fetchRoleList() {
      this.roleLoading = true;
      try {
        // const res = await getRoleListApi();
        // this.roleList = res.data || [];
        const params = {

          mrRoleNameCn : this.roleQuery.mrRoleNameCn  || undefined,
          mrRoleNameEn : this.roleQuery.mrRoleNameEn  || undefined,

          page: this.rolePagination.page,
          limit: this.rolePagination.limit,
        };

        const res = await this.$axios.post('/api/role/merlist',  params );
        if(res.data.code === 0){

          const responseData = res.data.data;
          this.roleList = responseData.records || []

          this.rolePagination.total =
            Number(responseData.total);

          this.rolePagination.page = Number(responseData.current);
          this.rolePagination.limit = Number(responseData.size);
        }


      } catch (error) {
        console.error("获取角色列表失败", error);
        this.roleLoading = false;
      }
    },
    // 角色列表 查询
    searchRole() {

      this.rolePagination.page = 1;

      this.fetchRoleList();

    },
    handleRoleSelectionChange(val) {
      this.selectedRoles = val;
    },
    // 确认选择并回填到表单
    confirmRoleSelection() {

      if (!this.selectedRoles.length) {
        this.$message.warning(this.$t('alert_select'));
        return;
      }
      this.formData.roleIdList = [];
      this.formData.roleNames = "";

    /*  const ids = this.selectedRoles
        .map(item => item.mrId)
        .join(',');*/

      const ids = this.selectedRoles.map(
        item => Number(item.mrId)
      );

      const names = this.selectedRoles
        .map(item => item.mrRoleNameCn)
        .join(',');

      this.formData.roleIdList = ids;
      this.formData.roleNames = names;

      this.roleDialogVisible = false;
    },
    // 关闭弹窗时清空勾选状态
    closeRoleDialog() {
      this.$refs.roleTable && this.$refs.roleTable.clearSelection();
      this.selectedRoles = [];
    },

    // 角色分页方法
    handleRolePageChange(page) {

      this.rolePagination.page = page;

      this.fetchRoleList();

    },
    handleRoleSizeChange(size) {

      this.rolePagination.limit = size;

      this.rolePagination.page = 1;

      this.fetchRoleList();

    },

    //删除
    async handleDelete() {

      if (!this.selectedRowData) {
        this.$message.warning(this.$t('alert_select'));
        return;
      }

      try {

        await this.$confirm(
            this.$t('findManagers.alertDel'),
            this.$t('tips'),
            {
              confirmButtonText: this.$t('sure'),
              cancelButtonText: this.$t('cancel'),
              type: "warning"
            }
        );

      /*  const params = {
          id: this.selectedRowData.maId
        };*/

        const res = await this.$axios.delete(
            `/api/meradmin/delete/${this.selectedRowData.maId}`
        );

        if (res.data.code === 0) {

          this.$message.success(this.$t('findManagers.delSucc'));

          // 清空选中
          this.selectedRowId = null;
          this.selectedRowData = null;

          // 刷新列表
          this.fetchOrderList();

        } else {

          this.$message.error(res.data.msg || "删除失败");

        }

      } catch (e) {

        // 点击取消时不会提示错误
        if (e !== "cancel") {
          console.error(e);
          this.$message.error("删除失败");
        }

      }

    },
    // 重置密码
    handleResetPassword(){

      if(!this.selectedRowData){
        this.$message.warning(this.$t('alert_select'));
        return;
      }


      this.resetPasswordData = {

        id:this.selectedRowData.maId,

        resetPass:""

      };


      this.resetPasswordAccount =
          this.selectedRowData.maMerLgginAccount;


      // 自动生成密码
      this.generatePassword();


      this.resetPasswordVisible=true;

    },
    // 自动生成密码
    generatePassword(){

      const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
      const digits = "0123456789";
      const allChars = letters + digits;
      const length = 8; // 可改为 8-16 之间的任意值

      // 1. 强制至少包含 1 个字母和 1 个数字
      let passwordArr = [
        letters[Math.floor(Math.random() * letters.length)],
        digits[Math.floor(Math.random() * digits.length)]
      ];

      // 2. 剩余位数从全部字符中随机填充
      for (let i = passwordArr.length; i < length; i++) {
        passwordArr.push(allChars[Math.floor(Math.random() * allChars.length)]);
      }

      // 3. 洗牌打乱顺序（避免前两位固定是字母+数字）
      for (let i = passwordArr.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [passwordArr[i], passwordArr[j]] = [passwordArr[j], passwordArr[i]];
      }

      this.resetPasswordData.resetPass = passwordArr.join("");

    },
    //重置密码提交
    async submitResetPassword(){
      try{

        this.resetPasswordLoading=true;

        const res = await this.$axios.put(
            "/api/meradmin/resetPassword",
            this.resetPasswordData
        );


        if(res.data.code===0){


          this.$message.success(this.$t('findManagers.resetpwd'));


          this.resetPasswordVisible=false;


        }else{
          this.$message.error(
              res.data.msg || "重置失败"
          );
        }

      }catch(e){
        console.error(e);

        this.$message.error("重置失败");

      }finally{
        this.resetPasswordLoading=false;

      }

    },
    // 停用
    handleStop(){

      if(!this.selectedRowData){
        this.$message.warning(this.$t('alert_select'));
        return;
      }


      if(this.selectedRowData.maStatus != 1){
        this.$message.warning(this.$t('findManagers.alertStop'));
        return;
      }


      this.$confirm(
          /*"确认停用该管理员吗？",*/
          this.$t('findManagers.adminHint'),
          this.$t('tips'),
          {
            confirmButtonText: this.$t('sure'),
            cancelButtonText: this.$t('cancel'),
            type:"warning"
          }
      ).then(async ()=>{


        const res = await this.$axios.put(
            `/api/meradmin/deactivate/${this.selectedRowData.maId}`
        );


        if(res.data.code === 0){
          this.$message.success(this.$t('findManagers.banSucc'));
          this.fetchOrderList();
          // 清空选中行
          this.selectedRowData = null;
          this.selectedRowId = null;
        }else{
          this.$message.error(
              res.data.msg || "停用失败"
          );
        }
      });
    },
    // 启用
    handleEnable(){

      if(!this.selectedRowData){
        this.$message.warning(this.$t('alert_select'));
        return;
      }


      if(this.selectedRowData.maStatus == 1){
        this.$message.warning(this.$t('findManagers.alertStart'));
        return;
      }


      this.$confirm(
          this.$t('findManagers.adminopen'),
          this.$t('tips'),
          {
            confirmButtonText: this.$t('sure'),
            cancelButtonText: this.$t('cancel'),
            type:"warning"
          }
      ).then(async ()=>{


        const res = await this.$axios.put(
            `/api/meradmin/activate/${this.selectedRowData.maId}`
        );


        if(res.data.code === 0){
          this.$message.success(this.$t('findManagers.EnabledSucc'));
          this.fetchOrderList();
          // 清空选中行
          this.selectedRowData = null;
          this.selectedRowId = null;
        }else{
          this.$message.error(
              res.data.msg || "启用失败"
          );
        }
      });
    },

    // 分页：每页条数变化
    handleSizeChange(val) {
      this.pagination.limit = val;
      this.pagination.page = 1; //
      this.fetchOrderList(); //
    },
    // 分页：当前页变化
    handleCurrentChange(val) {
      this.pagination.page = val;
      this.fetchOrderList(); //
    },
    // 处理选择id
    handleRowClick(row) {
      this.selectedRowIds = row.tsId;

    },


    // 表头宽度
    initColumnWidths() {
      const cols = [
        "loginName",
        "adminNameAll",
        "adminRole",
        "creator",
        "createdate",

      ];
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      ctx.font = '14px Helvetica';

      cols.forEach(key => {
        const label = this.$t(
          `findManagers.${key}`
        );

        this.$set(
          this.columnWidths,
          key,
          Math.ceil(ctx.measureText(label).width) + 50
        );
      });
    },
    resetForm() {
      this.formData = {
        maMerLgginAccount:"",
        maLoginPwd: '',
        renewPass: '',
        maName: '',
        roleNames: '',
        roleIdList: [],
        maRemark: '',

      };

      this.checkAllCurrency = false;

      // 清空选中行
      this.selectedRowData = null;
      this.selectedRowId = null;
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate();
      });
    },
  },
};
</script>

<style>
/* 全局样式 - 表头居中 */
.el-table th .cell {
  white-space: nowrap !important;
  text-align: center !important;
}

.el-table .cell {
  white-space: nowrap !important;
  text-align: center !important;
}
</style>

<style scoped>
.order-list {
  padding: 20px;
}

/* 确保输入框、下拉框、时间选择器在栅格中占满 100% 宽度 */
.full-width {
  width: 100% !important;
}

/* 使用 Flex 布局优雅处理 输入框 + More 按钮 的组合 */
.input-with-more {
  display: flex;
  align-items: center;
  width: 100%;
}

.input-with-more .el-input {
  flex: 1; /* 让输入框自动撑满剩余空间 */
}

.input-with-more .el-button {
  margin-left: 10px; /* 按钮和输入框之间的间距 */
  flex-shrink: 0; /* 防止按钮被挤压变形 */
}

/* 保持表格原有样式不变 */
.table-card ::v-deep .el-table .cell {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}
.table-card ::v-deep .el-table th .cell {
  white-space: nowrap !important;
}
.table-card {
  overflow-x: auto;
}

.table-card ::v-deep .el-table {
  min-width: 100%;
}


/* --- 修改 1：美化查询表单的标签字体 --- */
.query-card /deep/ .el-form-item__label {
  white-space: nowrap !important;
  font-weight: 600 !important; /* 强制加粗生效 */
  color: #303133 !important; /* 强制颜色深灰生效 */
  font-size: 14px !important;
  letter-spacing: 0.5px !important;
  min-width: 120px;
  text-align: right;
}


/* --- 修改 2：美化输入框内的字体和边框 --- */
.query-card /deep/ .el-input__inner {
  font-weight: 500 !important; /* 强制生效 */
  color: #606266 !important; /* 强制生效 */
  border-radius: 6px !important; /* 强制微圆角生效 */
}
/* 鼠标悬浮时输入框边框颜色加深一点点（可选增亮效果） */
.query-card /deep/ .el-input__inner:hover {
  border-color: #c0c4cc !important;
}

/* 操作工具栏样式 */
.action-toolbar {
  margin-top: 16px;     /* 与上方查询卡片拉开间距 */
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

/* 按钮之间的间距调整 */
.action-toolbar .el-button {
  margin-left: 10px;
  margin-right: 0;
}

.drawer-form {
  padding-right: 20px;
}

/*侧边弹窗*/
.drawer-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;

  padding: 15px 20px;

  border-top: 1px solid #ebeef5;
  background: #fff;

  text-align: right;
}
::v-deep .el-drawer__body {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}
.drawer-form {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
  padding-bottom: 80px;
}
.drawer-footer {
  flex-shrink: 0;
  padding: 15px 20px;
  border-top: 1px solid #ebeef5;
  background: #fff;
  text-align: right;
}
/*角色隐藏多选*/
.role-table /deep/ .el-table__header-wrapper .el-checkbox {
  display: none;
}



</style>



// WEBPACK FOOTER //
// src/view/admin/findManagers.vue